import { Box, Card, Grid, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// components
import Loader from 'react-loaders';
import { axiosInstance } from 'src/api/axios';
import PageContainer from 'src/components/container/PageContainer';
import Logo from 'src/layouts/full/shared/logo/Logo';
import AuthLogin from './auth/AuthLogin';

const Login2 = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      if (localStorage.getItem('token')) {
        axiosInstance
          .get('/users/profile')
          .then((response) => {
            if (response.status >= 400) {
              return;
            }
            if (response.status < 205 && response.data) {
              let { role } = response.data.user;
              if (role === 'admin') {
                navigate('/admin/');
              } else {
                navigate((window.location.href = '/dashboard'));
              }
            }
          })
          .catch((e) => {});
      }
    }, 2000);
  }, []);

  return (
    <PageContainer title="Login" description="this is Login page">
      {false ? (
        <Loader type={'ball-scale-multiple'} />
      ) : (
        <Box
          sx={{
            position: 'relative',
            '&:before': {
              content: '""',
              background: 'radial-gradient(#d2f1df, #d3d7fa, #bad8f4)',
              backgroundSize: '400% 400%',
              animation: 'gradient 15s ease infinite',
              position: 'absolute',
              height: '100%',
              minHeight: '700px',
              width: '100%',
              opacity: '0.3',
            },
          }}
        >
          <Grid
            container
            spacing={0}
            justifyContent="center"
            alignItems={'start'}
            sx={{ height: '100vh' }}
          >
            <Grid
              item
              xs={12}
              sm={12}
              lg={6}
              xl={6}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Card
                elevation={9}
                sx={{ p: 4, zIndex: 1, width: '100%', maxWidth: '500px', marginTop: '2.5rem' }}
              >
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Logo />
                </Box>
                <AuthLogin
                  subtext={
                    <Typography variant="h5" textAlign="center" color="black" mb={5}>
                      Log In To Continue Your Earning Journey
                    </Typography>
                  }
                  subtitle={
                    <Stack direction="row" spacing={1} justifyContent="start">
                      <Typography color="textSecondary" variant="h6" fontWeight="500">
                        New to EarnPati?
                      </Typography>
                      <Typography
                        component={Link}
                        to="/auth/register"
                        fontWeight="500"
                        sx={{
                          textDecoration: 'none',
                          color: 'earnpati.main',
                        }}
                      >
                        Create an account
                      </Typography>
                    </Stack>
                  }
                />
              </Card>
            </Grid>
          </Grid>
        </Box>
      )}
    </PageContainer>
  );
};

export default Login2;
